/* gi-variantes-hoja · 04/11/2026
   Hoja de variantes del móvil (ver snippets/gi-variantes-hoja.liquid).
   Al tocar «.gi-vh-btn» (ficha o barra fija) sube una hoja con todos los valores de esa opción:
   nombre, precio (o precio Black Friday si html.gi-bf-ver) y disponibilidad. Al elegir se pulsa la
   píldora equivalente y el tema hace el resto. La hoja se monta al abrirla y se quita al cerrarla.
   Listeners delegados en document: la ficha se re-renderiza con innerHTML al cambiar de variante. */
(function () {
  'use strict';
  if (window.GIVariantesHoja) return;
  window.GIVariantesHoja = true;

  var LANG = (document.documentElement.lang || 'es').slice(0, 2);
  var T = {
    es: { elige: 'Elige', cerrar: 'Cerrar', stock: 'En stock', pocas: 'Últimas unidades', camino: 'En camino', pedido: 'Bajo pedido · 3-10 días', agotado: 'Agotado', noHay: 'No disponible con lo que has elegido' },
    en: { elige: 'Choose', cerrar: 'Close', stock: 'In stock', pocas: 'Last units', camino: 'On its way', pedido: 'On backorder · 3-10 days', agotado: 'Sold out', noHay: 'Not available with your selection' },
    fr: { elige: 'Choisissez', cerrar: 'Fermer', stock: 'En stock', pocas: 'Dernières unités', camino: 'En route', pedido: 'Sur commande · 3-10 jours', agotado: 'Épuisé', noHay: 'Indisponible avec votre sélection' },
    de: { elige: 'Wähle', cerrar: 'Schließen', stock: 'Auf Lager', pocas: 'Letzte Stück', camino: 'Unterwegs', pedido: 'Auf Bestellung · 3-10 Tage', agotado: 'Ausverkauft', noHay: 'Mit deiner Auswahl nicht verfügbar' }
  };
  var L = T[LANG] || T.es;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function leeJSON(sel) {
    var el = document.querySelector(sel);
    try { return el ? JSON.parse(el.textContent || 'null') : null; } catch (e) { return null; }
  }

  // Opciones elegidas ahora: las del selector de la ficha (fuente de verdad); si no, las de la barra fija.
  function elegidas() {
    var sel = leeJSON('variant-selects [data-selected-variant]');
    if (sel && sel.options) return sel.options.slice();
    var out = [];
    document.querySelectorAll('.sticky-atc .sticky-atc__option-btn.is-selected').forEach(function (b) {
      out[Number(b.dataset.optionIndex)] = b.dataset.value;
    });
    return out;
  }

  // Disponibilidad con los mismos tramos que gi-fecha-entrega: a (hay/pocas), b, c, e, x.
  function disponibilidad(id) {
    var mapa = leeJSON('[data-gi-fe-data]') || {};
    var box = document.querySelector('[data-gi-fe-def]');
    var raw = String(Object.prototype.hasOwnProperty.call(mapa, id) ? mapa[id] : (box && box.getAttribute('data-gi-fe-def')) || '');
    var p = raw.split('|'), t = p[0];
    if (t === 'x') return { c: 'x', t: L.agotado };
    if (t === 'e') return { c: 'n', t: L.camino };
    if (t === 'c') return { c: 'n', t: L.pedido };
    if (t === 'a' && p[1] === 'pocas') return { c: 'n', t: L.pocas };
    if (t === 'a' || t === 'b') return { c: 'v', t: L.stock };
    return null;
  }

  // Por si algún precio llega con HTML (la app de conversión de moneda envuelve | money en un <span>)
  function txt(x) { return String(x == null ? '' : x).replace(/<[^>]*>/g, '').trim(); }

  function precioHTML(v) {
    var bfVer = document.documentElement.classList.contains('gi-bf-ver');
    if (bfVer && v.bf) {
      return '<b>' + esc(txt(v.bf.p)) + '</b><s>' + esc(txt(v.bf.r)) + '</s>' + (v.bf.pct > 0 ? '<i class="gi-vh__bf">BF −' + v.bf.pct + ' %</i>' : '');
    }
    return '<b>' + esc(txt(v.p)) + '</b>' + (v.c ? '<s>' + esc(txt(v.c)) + '</s>' : '');
  }

  // ------------------------------------------------------------ hoja
  var hoja = null, origen = null, yInicio = null;

  function abrir(btn) {
    var datos = leeJSON('[data-gi-vh-datos]');
    if (!datos || !datos.length) return;
    var idx = Number(btn.dataset.giVh);
    var actual = elegidas();
    var valores = [];
    datos.forEach(function (v) { if (valores.indexOf(v.o[idx]) < 0) valores.push(v.o[idx]); });

    var filas = valores.map(function (val) {
      var quiere = actual.slice(); quiere[idx] = val;
      var v = datos.find(function (d) { return d.o.every(function (o, i) { return o === quiere[i]; }); }) ||
              datos.find(function (d) { return d.o[idx] === val; });
      var exacta = v && v.o.every(function (o, i) { return o === quiere[i]; });
      var d = v ? disponibilidad(v.id) : null;
      var sel = actual[idx] === val;
      var gris = !v || !v.a || (d && d.c === 'x');
      return '<li><button type="button" class="gi-vh__fila' + (sel ? ' is-sel' : '') + (gris ? ' is-gris' : '') + '" data-v="' + esc(val) + '"' + (sel ? ' aria-current="true"' : '') + '>' +
        '<span class="gi-vh__marca" aria-hidden="true"></span>' +
        '<span class="gi-vh__info"><span class="gi-vh__nom">' + esc(val) + '</span>' +
        (exacta ? (d ? '<span class="gi-vh__disp gi-vh__disp--' + d.c + '"><i></i>' + esc(d.t) + '</span>' : '') : '<span class="gi-vh__disp gi-vh__disp--x"><i></i>' + esc(L.noHay) + '</span>') +
        '</span>' +
        (v ? '<span class="gi-vh__precio">' + precioHTML(v) + '</span>' : '') +
        '</button></li>';
    }).join('');

    cerrar(true);
    origen = btn;
    hoja = document.createElement('div');
    hoja.className = 'gi-vh';
    hoja.setAttribute('role', 'dialog');
    hoja.setAttribute('aria-modal', 'true');
    var titulo = L.elige + ' ' + String(btn.dataset.giVhNombre || '').toLowerCase();
    hoja.setAttribute('aria-label', titulo);
    hoja.innerHTML =
      '<div class="gi-vh__fondo" data-gi-vh-cerrar></div>' +
      '<div class="gi-vh__hoja">' +
        '<div class="gi-vh__cab"><span class="gi-vh__asa" aria-hidden="true"></span><b>' + esc(titulo) + '</b>' +
        '<button type="button" class="gi-vh__x" data-gi-vh-cerrar aria-label="' + esc(L.cerrar) + '">×</button></div>' +
        '<ul class="gi-vh__lista">' + filas + '</ul>' +
      '</div>';
    hoja.dataset.idx = idx;
    hoja.dataset.barra = btn.hasAttribute('data-gi-vh-barra') ? '1' : '';
    document.body.appendChild(hoja);
    document.documentElement.classList.add('gi-vh-abierta');
    btn.setAttribute('aria-expanded', 'true');

    var lista = hoja.querySelector('.gi-vh__lista');
    var elegida = hoja.querySelector('.gi-vh__fila.is-sel');
    if (elegida) lista.scrollTop = Math.max(0, elegida.offsetTop - lista.clientHeight / 2 + elegida.offsetHeight / 2);
    requestAnimationFrame(function () { if (hoja) hoja.classList.add('is-abierta'); (elegida || hoja.querySelector('.gi-vh__x')).focus({ preventScroll: true }); });

    hoja.addEventListener('click', function (e) {
      if (e.target.closest('[data-gi-vh-cerrar]')) { cerrar(); return; }
      var f = e.target.closest('.gi-vh__fila');
      if (f) elegir(Number(hoja.dataset.idx), f.dataset.v, hoja.dataset.barra === '1');
    });
    // Arrastrar la cabecera hacia abajo cierra la hoja, como la de Carina
    var cab = hoja.querySelector('.gi-vh__cab');
    cab.addEventListener('touchstart', function (e) { yInicio = e.touches[0].clientY; }, { passive: true });
    cab.addEventListener('touchmove', function (e) {
      if (yInicio == null || !hoja) return;
      var dy = Math.max(0, e.touches[0].clientY - yInicio);
      hoja.querySelector('.gi-vh__hoja').style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    cab.addEventListener('touchend', function (e) {
      if (yInicio == null || !hoja) return;
      var dy = e.changedTouches[0].clientY - yInicio;
      yInicio = null;
      if (dy > 80) cerrar(); else hoja.querySelector('.gi-vh__hoja').style.transform = '';
    });
  }

  function cerrar(rapido) {
    if (!hoja) return;
    var h = hoja;
    hoja = null;
    document.documentElement.classList.remove('gi-vh-abierta');
    if (origen) { origen.setAttribute('aria-expanded', 'false'); if (!rapido && document.contains(origen)) origen.focus({ preventScroll: true }); }
    if (rapido) { h.remove(); return; }
    h.classList.remove('is-abierta');
    setTimeout(function () { h.remove(); }, 250);
  }

  // Elegir = pulsar la píldora equivalente: el tema actualiza precio, galería, URL y la otra barra.
  function elegir(idx, val, desdeBarra) {
    var hecho = false;
    if (desdeBarra) {
      var b = [].find.call(document.querySelectorAll('.sticky-atc .sticky-atc__option-btn'), function (x) {
        return Number(x.dataset.optionIndex) === idx && x.dataset.value === val;
      });
      if (b) { b.click(); hecho = true; }
    }
    if (!hecho) {
      var fs = document.querySelector('variant-selects [data-gi-vh-opcion="' + idx + '"]');
      var r = fs && [].find.call(fs.querySelectorAll('input[type="radio"]'), function (x) { return x.value === val; });
      if (r) r.click();
    }
    cerrar();
    setTimeout(refrescar, 0);
    setTimeout(refrescar, 400);
  }

  // La línea de la barra fija no se re-renderiza: se copia el valor de la píldora marcada.
  function refrescar() {
    document.querySelectorAll('.sticky-atc [data-gi-vh-barra]').forEach(function (btn) {
      var idx = Number(btn.dataset.giVh);
      var b = [].find.call(document.querySelectorAll('.sticky-atc .sticky-atc__option-btn.is-selected'), function (x) {
        return Number(x.dataset.optionIndex) === idx;
      });
      var t = btn.querySelector('.gi-vh-btn__txt');
      if (b && t && t.textContent !== b.dataset.value) t.textContent = b.dataset.value;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.gi-vh-btn');
    if (btn) { e.preventDefault(); abrir(btn); return; }
    if (e.target.closest && e.target.closest('.sticky-atc__option-btn, variant-selects')) setTimeout(refrescar, 50);
  });
  document.addEventListener('change', function () { setTimeout(refrescar, 50); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && hoja) cerrar(); });
  // Si se pasa a escritorio con la hoja abierta (girar la tableta), se cierra
  window.addEventListener('resize', function () { if (hoja && window.innerWidth >= 750) cerrar(true); });
})();
